import { ElementType, PropsWithChildren } from 'react';
import cx from 'classnames';

import { THCComponentProps } from '@motorway/mw-highway-code/src/types';
import { filterDataProps, filterEventHandlerProps } from '@motorway/mw-highway-code/src/utils/helpers';

import styles from './Frame.module.scss';

export type FrameElementType = 'div' | 'section' | 'article';

export const Frame = <E extends FrameElementType = FrameElementType>(
  props: Prettify<
    THCComponentProps<
      PropsWithChildren
      & Partial<React.HTMLAttributes<HTMLElementTagNameMap[E]>>
      & {
        /**
         * Sets the element type of the component
         * @default 'div'
         */
        element?: E;
      }
    > & {
      className?: cx.Argument;
      fadeIn?: boolean;
      variant?: 'card' | 'flat';
    }
  >,
) => {
  const { children, className, element = 'div' as E, fadeIn = true, variant = 'card', ...rest } = props;
  const TagName = element as ElementType;

  return (
    <TagName className={cx(styles.frame, className, { [styles.fadeIn]: fadeIn }, styles[variant])}
      {...filterDataProps(rest)}
      {...filterEventHandlerProps(rest)}
    >
      {children}
    </TagName>
  );
};
